// Japanese translations
export const ja = {
  brandName: "GateGroup Inc",
  login: "ログイン",
  register: "登録",
  logout: "ログアウト",
  dashboard: "ダッシュボード",
  settings: "設定",
  adminPanel: "管理パネル",
  search: "検索",
  viewAll: "すべて見る",
  learnMore: "詳細を見る",
  getStarted: "始める",
  downloadApp: "アプリをダウンロード",
  
  nav: {
    trade: "取引",
    markets: "市場",
    earn: "稼ぐ",
    learn: "学ぶ",
    more: "その他",
    spotTrading: "現物取引",
    spotTradingDesc: "2,000以上の仮想通貨を売買",
    futures: "先物取引",
    futuresDesc: "最大125倍のレバレッジで取引",
    marginTrading: "信用取引",
    marginTradingDesc: "取引力を増幅",
    copyTrading: "コピートレード",
    copyTradingDesc: "トップトレーダーを自動フォロー",
    tradingBots: "取引ボット",
    tradingBotsDesc: "24時間年中無休で自動化",
    p2pTrading: "P2P取引",
    p2pTradingDesc: "他のユーザーと直接取引",
    marketOverview: "市場概要",
    marketOverviewDesc: "すべての市場と価格",
    cryptocurrencies: "仮想通貨",
    cryptocurrenciesDesc: "BTC、ETH、その他2000以上",
    newListings: "新規上場",
    newListingsDesc: "最新のトークン追加",
    topGainers: "上昇率上位",
    topGainersDesc: "本日のベストパフォーマー",
    simpleEarn: "シンプルアーン",
    simpleEarnDesc: "最大12% APYの柔軟な貯蓄",
    staking: "ステーキング",
    stakingDesc: "ロックして報酬を獲得",
    launchpool: "ローンチプール",
    launchpoolDesc: "新しいトークンをファーム",
    hodlerAirdrops: "HODLerエアドロップ",
    hodlerAirdropsDesc: "ホルダーへの報酬",
    cryptoAcademy: "クリプトアカデミー",
    cryptoAcademyDesc: "全レベル向けコース",
    videoTutorials: "ビデオチュートリアル",
    videoTutorialsDesc: "ステップバイステップガイド",
    articlesGuides: "記事とガイド",
    articlesGuidesDesc: "深い知識",
    helpCenter: "ヘルプセンター",
    helpCenterDesc: "FAQとサポート",
    aboutUs: "会社概要",
    aboutUsDesc: "私たちのストーリーとミッション",
    security: "セキュリティ",
    securityDesc: "お客様を守る方法",
    proofOfReserves: "準備金証明",
    proofOfReservesDesc: "100%の透明性",
    careers: "採用情報",
    careersDesc: "チームに参加",
  },
  
  hero: {
    title1: "あなたの",
    title2: "仮想通貨への入口",
    subtitle: "",
    traders: "4,900万人",
    tradersText: "以上のトレーダーに信頼されています",
    continueWith: "または続ける",
  },
  
  stats: {
    volume24h: "24時間取引高",
    cryptocurrencies: "仮想通貨",
    simpleEarnApy: "シンプルアーンAPY",
    reserveRatio: "準備金率",
  },
  
  products: {
    title: "いつでもどこでも取引",
    subtitle: "あらゆる取引戦略に対応する多様な製品",
    spotTrading: "現物取引",
    spotDesc: "2000以上のペア",
    futures: "先物取引",
    futuresDesc: "最大125倍レバレッジ",
    copyTrading: "コピートレード",
    copyDesc: "エキスパートをフォロー",
    tradingBots: "取引ボット",
    botsDesc: "24時間自動化",
    simpleEarn: "シンプルアーン",
    earnDesc: "柔軟な利回り",
    launchpool: "ローンチプール",
    launchDesc: "新しいトークン",
    popular: "人気",
    hot: "ホット",
    easy: "簡単",
    smart: "スマート",
    earn: "稼ぐ",
    exclusive: "限定",
  },
  
  howToStart: {
    title: "始め方",
    step1Title: "アカウント作成",
    step1Desc: "登録して限定ウェルカム報酬を獲得",
    step2Title: "クイック購入",
    step2Desc: "簡単なステップで仮想通貨を購入",
    step3Title: "取引開始",
    step3Desc: "取引、コピートレード、さらに稼ぐ",
    welcomeBonus: "ウェルカムボーナス",
    forNewUsers: "新規ユーザー向け",
  },
  
  security: {
    title: "すべての取引を保護",
    subtitle: "資産を守る多層セキュリティ",
    advancedSecurity: "高度なセキュリティ",
    advancedSecurityDesc: "監査済みスマートコントラクトとオンチェーン監視で脆弱性を防止",
    proofOfReserves: "準備金証明",
    proofOfReservesDesc: "透明な監査による100%準備金を提供する最初のプラットフォーム",
    secureStorage: "安全な保管",
    secureStorageDesc: "資産を保護する戦略的コールドウォレット保管",
  },
  
  cta: {
    title: "今日から始めよう",
    subtitle: "世界中の何百万ものトレーダーに参加し、安全で信頼性の高い取引体験を楽しもう",
    createAccount: "無料アカウントを作成",
    exploreMarkets: "市場を探索",
  },
  
  footer: {
    products: "製品",
    services: "サービス",
    support: "サポート",
    company: "会社",
    legal: "法的事項",
    description: "何百万ものユーザーに信頼されるグローバル取引プラットフォーム。安全かつ透明に取引。",
    downloadApp: "アプリをダウンロード",
    sslEncrypted: "SSL暗号化",
    reserves: "準備金",
    securityAudited: "セキュリティ監査済み",
    allRightsReserved: "無断転載禁止",
    riskWarning: "リスク警告：仮想通貨取引は高いリスクを伴います。取引前にリスクを理解してください。",
    termsOfService: "利用規約",
    privacyPolicy: "プライバシーポリシー",
    riskDisclosure: "リスク開示",
    amlPolicy: "AMLポリシー",
    helpCenter: "ヘルプセンター",
    faq: "FAQ",
    fees: "手数料",
    apiDocs: "APIドキュメント",
    submitRequest: "リクエスト送信",
    aboutGateGroup: "GateGroupについて",
    news: "ニュース",
    partnerships: "パートナーシップ",
    buyCrypto: "仮想通貨を購入",
  },
  
  promo: {
    signUpNow: "今すぐ登録して最大",
    upTo: "",
    inRewards: "の報酬を獲得",
  },
  
  priceCard: {
    hot: "ホット",
    new: "新着",
    gainers: "上昇",
  },
  
  partners: {
    officialPartner: "公式パートナー：",
  },
  
  loginPage: {
    title: "ログイン",
    welcome: "GateGroupへようこそ",
    email: "メールアドレス",
    password: "パスワード",
    forgotPassword: "パスワードを忘れた？",
    loggingIn: "ログイン中...",
    continueWith: "または続ける",
    noAccount: "アカウントがない？",
    registerNow: "今すぐ登録",
    demoAccount: "デモアカウント：",
    invalidCredentials: "メールまたはパスワードが無効",
    twoFactorTitle: "二要素認証",
    twoFactorDesc: "認証アプリのコードを入力",
    verify: "確認",
    goBack: "戻る",
    invalidCode: "確認コードが無効",
  },
  
  registerPage: {
    title: "アカウント作成",
    subtitle: "今日GateGroupに参加",
    welcomeBonus: "$100ウェルカムボーナス",
    bonusDesc: "今すぐ登録してボーナスを獲得",
    firstName: "名",
    lastName: "姓",
    confirmPassword: "パスワード確認",
    agreeToTerms: "同意します",
    termsOfService: "利用規約",
    and: "と",
    privacyPolicy: "プライバシーポリシー",
    creatingAccount: "アカウント作成中...",
    createAccount: "アカウントを作成",
    registerWith: "または登録する",
    haveAccount: "すでにアカウントがある？",
    mustAgree: "利用規約に同意する必要があります",
    passwordMismatch: "パスワードが一致しません",
    passwordLength: "パスワードは6文字以上必要です",
    accountFailed: "アカウント作成に失敗",
  },
  
  marketsPage: {
    title: "市場",
    subtitle: "価格、時価総額、取引量を追跡",
    totalMarketCap: "総時価総額",
    volume24h: "24時間取引高",
    btcDominance: "BTC優位性",
    activeCryptos: "アクティブな仮想通貨",
    all: "すべて",
    hot: "ホット",
    newListings: "新規上場",
    topGainers: "上昇率上位",
    topLosers: "下落率上位",
    searchCoins: "コインを検索...",
    filter: "フィルター",
    name: "名前",
    price: "価格",
    change24h: "24時間変動",
    volume: "24時間取引高",
    action: "アクション",
    trade: "取引",
    loadMore: "もっと読み込む",
    readyToTrade: "取引の準備はできた？",
    joinMillions: "何百万ものトレーダーに参加して、今日から仮想通貨の旅を始めよう",
  },
  
  learnPage: {
    title: "学ぶ",
    titleHighlight: "仮想通貨",
    titleEnd: "取引",
    subtitle: "仮想通貨取引をマスターするための無料コース、チュートリアル、ガイド",
    searchPlaceholder: "コース、記事、動画を検索...",
    all: "すべて",
    beginner: "初心者",
    trading: "取引",
    security: "セキュリティ",
    defi: "DeFi",
    featuredCourses: "おすすめコース",
    viewAll: "すべて見る",
    videoTutorials: "ビデオチュートリアル",
    articlesGuides: "記事とガイド",
    faq: "よくある質問",
    faqSubtitle: "一般的な質問への迅速な回答",
    viewAllFaqs: "すべてのFAQを見る",
    readyToPractice: "知識を活用する準備はできた？",
    startTradingConfidence: "学んだことを使って自信を持って取引を始めよう",
    startTradingNow: "今すぐ取引を始める",
    lessons: "レッスン",
    views: "回視聴",
    minRead: "分で読める",
  },
  
  companyPage: {
    title: "について",
    titleHighlight: "GateGroup",
    subtitle: "仮想通貨をアクセスしやすく、安全で、シンプルにすることで金融の未来を構築。",
    registeredUsers: "登録ユーザー",
    countriesServed: "サービス提供国",
    dailyVolume: "日次取引高",
    cryptocurrencies: "仮想通貨",
    ourStory: "私たちのストーリー",
    ourStoryP1: "GateGroupは2017年に設立され、シンプルな使命を持っていました：誰もが仮想通貨取引にアクセスできるようにすること。",
    ourStoryP2: "熱心な仮想通貨愛好家の小さなチームから、世界中の何百万ものユーザーにサービスを提供するグローバルプラットフォームに成長しました。",
    ourStoryP3: "今日、私たちは世界をリードする仮想通貨取引所の1つであることを誇りに思います。",
    ourValues: "私たちの価値観",
    ourValuesSubtitle: "すべての行動を導く原則",
    securityFirst: "セキュリティ第一",
    securityFirstDesc: "ユーザー資産の安全を最優先しています。",
    userCentric: "ユーザー中心",
    userCentricDesc: "すべての決定はユーザーにとって最善のことに基づいています。",
    innovation: "イノベーション",
    innovationDesc: "最先端の取引ソリューションを提供するために常に限界を押し広げています。",
    globalAccess: "グローバルアクセス",
    globalAccessDesc: "どこにいても誰もが仮想通貨にアクセスできるようにする。",
    securityTrust: "セキュリティと信頼",
    securityTrustSubtitle: "あなたのセキュリティは私たちの最優先事項です",
    proofOfReserves: "準備金証明",
    proofOfReservesDesc: "ユーザー資産の100%がいつでもオンチェーンで検証可能。",
    coldStorage: "コールドストレージ",
    coldStorageDesc: "資産の大部分は安全なオフラインコールドウォレットに保管。",
    regularAudits: "定期監査",
    regularAuditsDesc: "第三者セキュリティ監査が最高水準を保証。",
    insuranceFund: "保険基金",
    insuranceFundDesc: "予期せぬ事態からユーザーを保護する専用基金。",
    leadershipTeam: "リーダーシップチーム",
    leadershipSubtitle: "私たちのミッションを推進する人々を紹介",
    globalPresence: "グローバルプレゼンス",
    globalPresenceSubtitle: "地域サポートで世界中のユーザーにサービス提供",
    joinOurTeam: "チームに参加",
    joinTeamDesc: "仮想通貨への情熱を共有する才能ある人材を常に探しています。",
    viewOpenPositions: "募集中のポジションを見る",
    teamMembers: "チームメンバー",
    countries: "カ国",
    openRoles: "募集中のポジション",
    remoteFriendly: "リモートフレンドリー",
    getInTouch: "お問い合わせ",
    getInTouchSubtitle: "ご質問がありますか？お手伝いします",
    emailUs: "メールを送る",
  },
  
  chat: {
    title: "GateGroupアシスタント",
    online: "オンライン",
    welcomeMessage: "こんにちは！👋 GateGroup AIアシスタントです。\n\n本日はどのようにお手伝いできますか？",
    placeholder: "メッセージを入力...",
    poweredBy: "AIによって動作",
    instantSupport: "24時間年中無休サポート",
    newChat: "新しいチャット",
    errorMessage: "申し訳ございません、エラーが発生しました。もう一度お試しください。",
    connectionError: "申し訳ございません、接続エラーです。後でもう一度お試しください。",
    quickQuestion1: "取引を始めるには？",
    quickQuestion2: "手数料は？",
    quickQuestion3: "入金方法は？",
    quickQuestion4: "プラットフォームは安全？",
  },
  
  languages: {
    ar: "العربية",
    en: "English",
    es: "Español",
    de: "Deutsch",
    zh: "中文",
    ja: "日本語",
    he: "עברית",
  },
};

export default ja;
